import { useTheme } from "@mui/material";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import { Box } from "@/Components/v2/atoms/Box";
import { Button } from "@/Components/v2/atoms/Button";
import OutlinedButton2 from "@/Components/v2/atoms/Button/OutlinedButton2";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { colors } from "@/Components/v2/utils/brand-colors";
import { useAnalytics } from "@/hooks/useAnalytics";
import NewScenarioModalPage from "@/pages/scenario-builder/v3/pages/new-scenario-modal/NewScenarioModalPage";
import { QuickSimulateButton } from "@/pages/scenario-builder/v3/pages/scenarios/components/QuickSimulateButton";

import GraphImage from "../images/graph.png";

const ScenarioBuilderCard = ({ ...stackProps }) => {
  const theme = useTheme();
  const history = useHistory();
  const { buttonClicked } = useAnalytics();

  const [customBuildOpen, setCustomBuildOpen] = useState(false);

  const handleCustomBuildClick = () => {
    buttonClicked({
      buttonName: "Custom Build",
      buttonLocation: "Growth Center - Scenario Builder Card",
      buttonType: "modal",
    });

    setCustomBuildOpen(true);
  };

  const handleViewScenariosClick = () => {
    buttonClicked({
      buttonName: "View Scenarios",
      buttonLocation: "Growth Center - Scenario Builder Card",
      buttonType: "navigation",
      additionalProperties: {
        destination: "/scenarios-v3/all",
      },
    });
  };

  const handleQuickSimulateSubmit = () => {
    buttonClicked({
      buttonName: "Quick Build Submit",
      buttonLocation: "Growth Center - Scenario Builder Card",
      buttonType: "navigation",
      additionalProperties: {
        destination: "/scenarios-v3/all",
      },
    });

    history.push("/scenarios-v3/all");
  };

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      padding="2rem"
      {...stackProps}
    >
      <Box pr={6}>
        <Box mb={2}>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: theme.palette.mode === "dark" ? colors.white : colors.black,
            }}
          >
            Measure, Forecast, Optimize
          </Typography>
          <Typography
            variant="body2"
            sx={{
              lineHeight: 1.6,
              fontSize: "1rem",
              color: theme.palette.mode === "dark" ? colors.white : colors.black,
            }}
          >
            The market isn&apos;t set and forget and neither is your media investment plan. Use
            Scenario Builder to forecast and optimize your approach with zero risk.
          </Typography>
        </Box>

        <Stack direction={"row"} spacing={2}>
          <OutlinedButton2 variant="outlined" onClick={handleCustomBuildClick}>
            Custom Build
          </OutlinedButton2>
          <NewScenarioModalPage
            open={customBuildOpen}
            handleClose={() => setCustomBuildOpen(false)}
          />
          <QuickSimulateButton onSubmit={handleQuickSimulateSubmit} />
          <Link to={"scenarios-v3/all"} onClick={handleViewScenariosClick}>
            <Button
              variant="text"
              sx={{
                color: theme.palette.mode === "dark" ? colors.white : colors.lightBlack,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              View Scenarios
            </Button>
          </Link>
        </Stack>
      </Box>
      <Box>
        <img src={GraphImage} alt="Scenario Builder Report" width="400px" />
      </Box>
    </Stack>
  );
};

export default ScenarioBuilderCard;
